import { useQuery } from '@tanstack/react-query';

import { getAppIdBySlug } from '@services/sample-requests/app.service';

export function useAppIdBySlug(slug: string) {
  return useQuery({
    queryKey: ['app-id', slug],
    queryFn: () => getAppIdBySlug(slug),
    enabled: !!slug,
  });
}
